import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import SuscriptionTypeForm from "@components/forms/SuscriptionTypeForm";

type SuscriptionTypeAddEditProps = {
  copyData?: boolean
}

const SuscriptionTypeAddEdit = (props: SuscriptionTypeAddEditProps) => {
  const { copyData = false } = props
  const params = useParams()
  const { id: copySuscriptionTypeId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!copyData && copySuscriptionTypeId ? "Modificar" : "Agregar"} Tipo de Suscripcion`}
      backUrl="/admin/suscription-types"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "SuscriptionTypeAddEdit",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <SuscriptionTypeForm
        id={copySuscriptionTypeId}
        copyData={copyData}
        saveRedirectUrl="/admin/suscription-types"
        formId="SuscriptionTypeAddEdit" >
      </SuscriptionTypeForm>

    </PageContainer>
  );
}

export default SuscriptionTypeAddEdit;
